<oui-tag type="status" [status]="statusColor" size="big">
    {{ statusText }}
  </oui-tag>
  
